// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1664":"783ea38304863b18","2888":"f1c57aa118a9c268"}[chunkId] + ".css";
};